module.exports = __webpack_public_path__ + "img/ini-logo.5213f399.png";